export default function(original, regExp, newSubString, single) {
    if (typeof original === 'string') {
        return original.replace(new RegExp(regExp, single ? undefined : 'g'), newSubString);
    }
}
